/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FileTypeTextIcon20Solid = forwardRef('FileTypeTextIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.988 2.586A2 2 0 0 0 11.573 2H6a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V7.427a2 2 0 0 0-.586-1.415l-3.426-3.426ZM6.5 8a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H11v4.5a1 1 0 1 1-2 0V9H7.5a1 1 0 0 1-1-1Z" })));
});
